import React from 'react';

interface FooterProps {
  isDark: boolean;
}

const Footer: React.FC<FooterProps> = ({ isDark }) => {
  return (
    <footer className={`py-8 text-center ${isDark ? 'bg-gray-900 border-t border-gray-800' : 'bg-gray-100 border-t border-gray-200'}`}>
      <p className={`text-sm mb-2 ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
        Note: This site is not affiliated with or related to any YouTube channel of the same name.
      </p>
      <p className={isDark ? 'text-gray-400' : 'text-gray-600'}>
        © 2026 Shmeevee. Built with React & TypeScript.
      </p>
    </footer>
  );
};

export default Footer;